import { fromJS } from 'immutable'

import {
  CLIENTS_FETCHED,
  SEARCH_TERM_CHANGED,
  START_FETCHING,
  FILTER_CHANGED
} from './constants'

export const initialState = fromJS({
  searchTerm: '',
  filter: {
    state: null,
    city: null,
  },
  clients: [],
  pagination: {
    prev: null,
    next: null
  }
})


export default function reducer(state = initialState, action) {
  switch(action.type) {
    case FILTER_CHANGED:
      return state.merge({
        filter: {
          city: action.city,
          state: action.state
        }
      })
    case START_FETCHING:
      return state.set('isFetching', true)
    case SEARCH_TERM_CHANGED:
      return state.set('searchTerm', action.searchTerm)
    case CLIENTS_FETCHED:
      const prevClients = state.get('clients').toJS()
      const clients = action.isNextPage ? prevClients.concat(action.clients) : action.clients
      return state.merge({
        isFetching: false,
        clients: clients,
        pagination: {
          prev: action.prevPage,
          next: action.nextPage
        }
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Clients/reducer.js